/**
 * O CATÁLOGO DE HISTÓRIAS (manual v2.1, p.46 a p.49; M34).
 *
 * "No código da tela, o elemento recebe data-historia="IND-PNL-01". O cartão
 * sai do catálogo de histórias por esse código." O catálogo descreve o
 * SISTEMA, e por isso mora aqui, versionado com a tela: se a tela mudar o
 * rótulo ou a conta, a história muda no mesmo commit. O que é dado — a
 * conferência e a divergência do QA — mora no banco (0080).
 *
 * Código: TIPO-MÓDULO-NN (p.49). O papel é sempre um perfil real do sistema.
 */

import { HISTORIAS as HISTORIAS_C } from './grupos/estoque-custos-cadastros-acesso';
import { HISTORIAS as HISTORIAS_B } from './grupos/operacao-manutencao-inspecao';
import { HISTORIAS as HISTORIAS_A } from './grupos/painel-equipamentos-combustivel';

export type TipoDaHistoria = 'TEL' | 'IND' | 'BTN' | 'CMP' | 'COL' | 'NUM' | 'SEL' | 'FLT' | 'GRF' | 'ABA';
export type SituacaoDaHistoria = 'rascunho' | 'em_revisao' | 'aprovada';

export interface Historia {
  readonly codigo: string;
  /** O rótulo exato da tela. */
  readonly titulo: string;
  readonly papel: string;
  readonly quero: string;
  readonly para: string;
  readonly significa: string;
  /** A conta ou a regra, com unidade. Para botão, o que acontece ao tocar. */
  readonly calcula: string;
  /** Módulo e registro de origem, e quando o valor se atualiza. */
  readonly origem: string;
  /** O que o QA confere na tela: dois a quatro itens. */
  readonly criterios: readonly string[];
  readonly situacao: SituacaoDaHistoria;
  readonly responsavel: string;
  readonly revisadaEm: string;
}

export const ROTULO_DO_TIPO: Readonly<Record<TipoDaHistoria, string>> = {
  TEL: 'Tela', IND: 'Indicador', BTN: 'Botão', CMP: 'Campo', COL: 'Coluna', NUM: 'Número', SEL: 'Selo', FLT: 'Filtro', GRF: 'Gráfico', ABA: 'Aba',
};

export const ROTULO_DA_SITUACAO: Readonly<Record<SituacaoDaHistoria, string>> = {
  rascunho: 'Rascunho',
  em_revisao: 'Em revisão',
  aprovada: 'Aprovada',
};

/* Uma lista por grupo de módulos, na ordem do manual (p.51 a p.60). */
const lista: readonly Historia[] = [...HISTORIAS_A, ...HISTORIAS_B, ...HISTORIAS_C];

export const CATALOGO_DE_HISTORIAS: ReadonlyMap<string, Historia> = new Map(lista.map((h) => [h.codigo, h]));

export function tipoDoCodigo(codigo: string): TipoDaHistoria | null {
  const t = codigo.slice(0, 3);
  return t in ROTULO_DO_TIPO ? (t as TipoDaHistoria) : null;
}

/** "Como gestor operacional, quero ver…, para remanejar…" — a frase do cartão. */
export function fraseDaHistoria(h: Historia): string {
  return `Como ${h.papel}, quero ${h.quero}, para ${h.para}.`;
}

export type EstadoDoMarcador = 'padrao' | 'conferida' | 'divergente' | 'sem_historia';

/** O estado do marcador (p.47): sem história no catálogo, ou a última conferência. */
export function estadoDoMarcador(codigo: string, conferencia: { readonly situacao: 'conferida' | 'divergente' } | undefined): EstadoDoMarcador {
  if (!CATALOGO_DE_HISTORIAS.has(codigo)) return 'sem_historia';
  return conferencia?.situacao ?? 'padrao';
}
